export const PAGE_PATH = {
  home: '/',
  spots: '/spots',
  spotDetail: '/spots/detail',
  rewards: '/rewards',
  rewardDetail: '/rewards/detail',
  mypage: '/mypage',
  news: '/news',
  qr: '/qr',
  qrError: '/qrerror',
  notice: '/notice',
  inquiries: '/inquiries',
  inquiriesConfirm: '/inquiries/confirm',
  ocrForm: '/ocr/form',
  ocrReceipt: '/ocr/receipt',
  pointHistory: '/pointHistory',
  reset: '/reset',
  resetFinish: '/resetfinish',
  restore: '/restore',
  rule: '/rule',
  service: '/service',
  payment: '/payment',
  reservation: '/reservation',
  error500: '/500',
} as const

export type PagePath = (typeof PAGE_PATH)[keyof typeof PAGE_PATH]

type FetchLogFields = {
  fetch_method: 'GET' | 'POST'
  fetch_url: string
  fetch_params?: Record<string, unknown> | string
}

type LogArgs = {
  page?: PagePath
  xstate?: string
  msg: string
} & Partial<FetchLogFields>

type LogEntry = LogArgs & {
  timestamp: string
}

function formatTimestamp(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
  )
}

function isLogEnabled(): boolean {
  return process.env.NEXT_PUBLIC_LOG_ENABLED === 'true'
}

function buildEntry(args: LogArgs): LogEntry {
  return {
    ...args,
    timestamp: formatTimestamp(new Date()),
  }
}

export const logger = {
  /**
   * 情報ログ（NEXT_PUBLIC_LOG_ENABLED=true のときのみ出力）
   */
  info: (args: LogArgs): void => {
    if (isLogEnabled()) {
      console.log(buildEntry(args))
    }
  },
  /**
   * 警告ログ（NEXT_PUBLIC_LOG_ENABLED=true のときのみ出力）
   */
  warn: (args: LogArgs): void => {
    if (isLogEnabled()) {
      console.warn(buildEntry(args))
    }
  },
  /**
   * エラーログ（NEXT_PUBLIC_LOG_ENABLED=true のときのみ出力）
   */
  error: (args: LogArgs): void => {
    if (isLogEnabled()) {
      console.error(buildEntry(args))
    }
  },
}
